export default "__VITE_PUBLIC_ASSET__be7a3a28__"